import { IkeUnitDistance, type Point, type Size } from '@ikegps/core-api';
import { IkeUnit } from '../../unit';
import { IkeDraw } from '../draw';
import { m } from '../mithril';
import { StyleConfig } from '../theme';

export interface CrosshairCtx {
	center: Point;
	size: Size;
	units: IkeUnitDistance;
	gap: number;
	classNames: { outerLine: string; innerLine: string; distance: string };
	scale: number;
	innerStroke: string;
	outerStroke: string;
	distance?: number;
}

export function view(dc: IkeDraw, ctx: CrosshairCtx) {
	if (!dc.isIkePhoto) {
		return null;
	}

	var { size, center, gap, classNames, scale, distance } = ctx;
	var strokeWidth = scale * 2;

	var halfHeight = size.height / 2;
	var halfWidth = size.width / 2;
	var elements = [];
	// Left to right
	elements.push(
		m('line', {
			className: classNames.outerLine,
			x1: center.x - halfWidth,
			y1: center.y,
			x2: center.x - gap,
			y2: center.y,
			'stroke-width': strokeWidth * 2 + 'px',
			stroke: ctx.outerStroke,
		})
	);

	elements.push(
		m('line', {
			className: classNames.innerLine,
			x1: center.x - halfWidth,
			y1: center.y,
			x2: center.x - gap,
			y2: center.y,
			'stroke-width': strokeWidth + 'px',
			stroke: ctx.innerStroke,
		})
	);

	// Right to left
	elements.push(
		m('line', {
			className: classNames.outerLine,
			x1: center.x + gap,
			y1: center.y,
			x2: center.x + halfWidth,
			y2: center.y,
			'stroke-width': strokeWidth * 2 + 'px',
			stroke: ctx.outerStroke,
		})
	);

	elements.push(
		m('line', {
			className: classNames.innerLine,
			x1: center.x + gap,
			y1: center.y,
			x2: center.x + halfWidth,
			y2: center.y,
			'stroke-width': strokeWidth + 'px',
			stroke: ctx.innerStroke,
		})
	);

	// Top to bottom
	elements.push(
		m('line', {
			className: classNames.outerLine,
			x1: center.x,
			y1: center.y - halfHeight,
			x2: center.x,
			y2: center.y - gap,
			'stroke-width': strokeWidth * 2 + 'px',
			stroke: ctx.outerStroke,
		})
	);

	elements.push(
		m('line', {
			className: classNames.innerLine,
			x1: center.x,
			y1: center.y - halfHeight,
			x2: center.x,
			y2: center.y - gap,
			'stroke-width': strokeWidth + 'px',
			stroke: ctx.innerStroke,
		})
	);

	// Bottom to top
	elements.push(
		m('line', {
			className: classNames.outerLine,
			x1: center.x,
			y1: center.y + gap,
			x2: center.x,
			y2: center.y + halfHeight,
			'stroke-width': strokeWidth * 2 + 'px',
			stroke: ctx.outerStroke,
		})
	);

	elements.push(
		m('line', {
			className: classNames.innerLine,
			x1: center.x,
			y1: center.y + gap,
			x2: center.x,
			y2: center.y + halfHeight,
			'stroke-width': strokeWidth + 'px',
			stroke: ctx.innerStroke,
		})
	);

	if (!isNaN(distance)) {
		var distanceText = m(
			'text',
			{
				className: classNames.distance,
				fill: StyleConfig.FONT_COLOR,
				stroke: 'none',
				x: halfWidth / 2,
				y: StyleConfig.FONT_SIZE,
				'text-anchor': 'middle',
				'font-size': StyleConfig.FONT_SIZE,
				'alignment-baseline': 'middle',
				style: {
					'user-select': 'none',
					'pointer-events': 'none',
					'font-weight': 'bold',
				},
			},
			IkeUnit.display(distance, ctx.units)
		);

		var distanceRect = m('rect', {
			x: 0,
			y: 0,
			width: halfWidth,
			stroke: 'none',
			height: 8 + StyleConfig.FONT_SIZE,
			fill: StyleConfig.LABEL.FILL,
			'fill-opacity': '0.75',
		});

		var offsetX = center.x - (halfWidth / 2) * scale;
		var offsetY = center.y + halfHeight * 1.25 + gap;

		elements.push(
			m(
				'g',
				{
					transform: `translate(${offsetX},${offsetY})scale(${scale})`,
				},
				[distanceRect, distanceText]
			)
		);
	}

	return m('g', { className: 'c-Draw-crosshair' }, elements);
}

export const Crosshair = { view };
